export default {"src":"/_next/static/media/businessTrashcan.168714c4.svg","height":30,"width":24,"blurWidth":0,"blurHeight":0};